<template>
  <div style="height:320px">
    <div style="text-align:left !important;">
      <!-- only mount once we have data -->
      <VueApexCharts
        v-if="series.length > 0"
        :key="id"
        :type="type"
        height="285"
        :options="clonedOptions"
        :series="clonedSeries"
      />
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import VueApexCharts from 'vue-apexcharts'

export default {
  name: 'DBar',
  components: { VueApexCharts },
  props: {
    id: { type: String, default: 'dbar' },
    source: { type: String, required: true },
    title: { type: String, default: '' },
    type: { type: String, default: 'bar' },
    labels: { type: String, default: 'default' },
    colors: { type: Array, default: () => ['#1ab7ea','#0084ff','#39539E','#0077B5'] },
    show_last_modification: { type: Boolean, default: false },
    start: { type: Number, default: 0 },
    end: { type: Number, default: 0 },
    range: { type: Boolean, default: false },
  },
  data() {
    return {
      appConfig: process.env.NODE_ENV === 'production'
        ? require('@src/app.config')
        : require('@src/app.config.dev'),
      series: [],
      chartOptions: {
        chart: { id: 'dbar-chart' },
        xaxis: {
          categories: [],
          labels: { hideOverlappingLabels: true, showDuplicates: false, trim: false }
        },
        fill: { colors: [] },
        plotOptions: {
          bar: {
            dataLabels: { orientation: 'vertical', position: 'center' }
          }
        },
        dataLabels: {
          enabled: true,
          offsetX: 0,
          style: { fontSize: '12px', colors: ['#fff'] }
        }
      }
    }
  },
  computed: {
    clonedOptions() {
      return JSON.parse(JSON.stringify(this.chartOptions))
    },
    clonedSeries() {
      return JSON.parse(JSON.stringify(this.series))
    }
  },
  methods: {
    getData() {
      if (this.show_last_modification) {
        // adjust padding if needed
      }
      if (!this.source) {
        console.error('DBar Error - source not defined')
        return
      }
      let url = this.source
      if (this.range) {
        if (this.start > 0) url += `&start=${this.start}`
        if (this.end > 0) url += `&end=${this.end}`
      }
      axios.get((this.appConfig.xdrAPI.baseURL || 'http://localhost:5000') + url)
        .then(resp => {
          if (resp.status !== 200) {
            if (resp.status === 404) {
              console.error('DBar Error - source not found')
              this.$emit('finished', this.id, false, 'source not found')
            }
            return
          }
          const payload = resp.data
          if (!Array.isArray(payload.data) || !payload.updated) {
            console.error('DBar Error - malformed response')
            return
          }
          const rev = [...payload.data].reverse()
          const categories = rev.map(entry => {
            if (this.labels !== 'default') {
              return entry.label || ''
            }
            let label = ''
            let sep = ''
            if (entry.year != null) { label += entry.year }
            if (entry.month != null) {
              sep = label ? '/' : ''
              label += sep + entry.month
            }
            if (entry.day != null) {
              sep = label ? '/' : ''
              label += sep + entry.day
            }
            if (entry.hour != null) {
              sep = label ? ' ' : ''
              label += sep + String(entry.hour).padStart(2, '0')
            }
            if (entry.minute != null) {
              sep = label ? ':' : ''
              label += sep + String(entry.minute).padStart(2, '0')
            }
            return label
          })
          const counts = rev.map(entry => entry.count != null ? entry.count : 0)
          this.series = [{ name: 'valor', data: counts }]
          this.chartOptions = {
            ...this.chartOptions,
            xaxis: { ...this.chartOptions.xaxis, categories },
            fill: { ...this.chartOptions.fill, colors: this.colors.slice() }
          }
          this.$emit('finished', this.id, true, `Series Length: ${this.series[0].data.length}`)
        })
        .catch(err => {
          console.error('Error loading DBar data:', err.response || err)
          this.$emit('finished', this.id, false, err.response || err)
          const status = err.response && err.response.status
          if (status === 401 || status === 403) {
            localStorage.removeItem('idToken')
            this.$router.push({ name: 'Home' })
          }
        })
    }
  },
  created() {
    this.getData()
  }
}
</script>

<style scoped>
.apexcharts-legend {
  padding-right: 80px;
  line-height: 5px;
  font-size: 8px;
}
</style>